<template>
  <v-container id="register" class="fill-height justify-center" tag="section">
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          light
          max-width="100%"
          width="700"
          class="px-5 py-3 mt-10"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">Register</h1>
            </div>
          </template>

          <v-card-title class="title font-weight-regular justify-space-between">
            <span style="font-size: 18px">{{ currentTitle }}</span>
            <v-avatar
              color="primary lighten-2"
              class="subheading white--text"
              size="24"
              v-text="step"
            ></v-avatar>
          </v-card-title>

          <v-window v-model="step">
            <v-window-item :value="1">
              <v-form ref="firstForm" v-model="firstValid" lazy-validation>
                <v-text-field
                  hide-details="auto"
                  v-model="name"
                  :rules="nameRules"
                  label="Name"
                  required
                ></v-text-field>

                <v-text-field
                  hide-details="auto"
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>

                <v-select
                  hide-details="auto"
                  v-model="clientType"
                  :items="items"
                  :rules="[(v) => !!v || 'Item is required']"
                  label="Item"
                  required
                ></v-select>

                <v-checkbox
                  :rules="[(v) => !!v || 'You must agree to continue!']"
                  label="Do you agree?"
                  required
                ></v-checkbox>
              </v-form>
            </v-window-item>
            <v-window-item :value="2">
              <h1>Register</h1>
              <v-form ref="secondForm" v-model="secondValid">
                <v-text-field
                  hide-details="auto"
                  :rules="nameRules"
                  label="Name"
                  required
                ></v-text-field>

                <v-text-field
                  hide-details="auto"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>

                <v-select
                  hide-details="auto"
                  v-model="clientType"
                  :items="items"
                  :rules="[(v) => !!v || 'Item is required']"
                  label="Item"
                  required
                ></v-select>

                <v-checkbox
                  :rules="[(v) => !!v || 'You must agree to continue!']"
                  label="Do you agree?"
                  required
                ></v-checkbox>
              </v-form>
            </v-window-item>
            <v-window-item :value="3">
              <h1>Register</h1>
              <v-form ref="thirdForm" v-model="thirdValid">
                <v-text-field
                  hide-details="auto"
                  :rules="nameRules"
                  label="Name"
                  required
                ></v-text-field>

                <v-text-field
                  hide-details="auto"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>

                <v-select
                  hide-details="auto"
                  :items="items"
                  :rules="[(v) => !!v || 'Item is required']"
                  label="Item"
                  required
                ></v-select>

                <v-checkbox
                  :rules="[(v) => !!v || 'You must agree to continue!']"
                  label="Do you agree?"
                  required
                ></v-checkbox>
              </v-form>
            </v-window-item>
            <v-window-item :value="4"> </v-window-item>
          </v-window>

          <v-card-actions>
            <v-btn :disabled="step === 1" text @click="back"> Back </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="step != 4"
              :color="step === 3 ? 'success' : 'primary'"
              depressed
              @click="next"
            >
              {{ step === 3 ? 'Confirm' : 'Next' }}
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Register',

  data: () => ({
    // step: 1,
    // firstValid: true,
    // secondValid: true,
    // thirdValid: true,
    // documentNumber: "",
    // documentRules: [
    //   (v) => !!v || "Campo de documentos é requerido",
    //   (v) =>
    //     (v && v.length <= 21) || "O documento deve ter no máximo 21 caracteres",
    // ],
    // fantasyName: "",
    // name: "",
    // nameRules: [
    //   (v) => !!v || "Nome é requerido",
    //   (v) => (v && v.length <= 128) || "Nome deve ter no máximo 128 caracteres",
    // ],
    // email: "",
    // emailRules: [
    //   (v) => !!v || "E-mail é requerido",
    //   (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    // ],
    // phoneNumber: "",
    // phoneNumber2: "",
    // phoneRules: [(v) => !!v || "E-mail is required"],
    // municipalRegistration: "",
    // municipalRegRules: [
    //   (v) => !!v || "Inscrição Municipal requerida",
    //   (v) =>
    //     (v && v.length <= 10) || "Inscrição deve ter no máximo 10 caracteres",
    // ],
    // stateRegistration: "",
    // stateRegRules: [
    //   (v) => !!v || "Inscrição Estadual requerida",
    //   (v) =>
    //     (v && v.length <= 9) || "Inscrição deve ter no máximo 9 caracteres",
    // ],
    // country: "",
    // countryRules: [(v) => !!v || "Nacionalidade requerida"],
    // birthDate: null,
    // birthRules: [(v) => !!v || "Data de Nascimento requerida"],
    // locationNumber: null,
    // locationRules: [(v) => !!v || "Numero requerido"],
    // postalCode: "",
    // postalCodeRules: [
    //   (v) => !!v || "CEP requerido",
    //   (v) => (v && v.length <= 10) || "CEP deve ter no máximo 10 caracteres",
    // ],
    // neighborhood: "",
    // neighborhoodRules: [
    //   (v) => !!v || "Bairro requerido",
    //   (v) => (v && v.length <= 30) || "Bairro deve ter no máximo 30 caracteres",
    // ],
    // address: "",
    // addressRules: [
    //   (v) => !!v || "Logradouro requerido",
    //   (v) =>
    //     (v && v.length <= 64) || "Logradouro deve ter no máximo 64 caracteres",
    // ],
    // state: "",
    // stateRules: [
    //   (v) => !!v || "Estado requerido",
    //   (v) => (v && v.length <= 32) || "Estado deve ter no máximo 32 caracteres",
    // ],
    // complement: "",
    // complementRules: [
    //   (v) => !!v || "Complemento requerido",
    //   (v) =>
    //     (v && v.length <= 64) || "Complemento deve ter no máximo 64 caracteres",
    // ],
    // city: "",
    // cityRules: [
    //   (v) => !!v || "Cidade requerida",
    //   (v) => (v && v.length <= 32) || "Cidade deve ter no máximo 32 caracteres",
    // ],
    // site: "",
    // siteRules: [(v) => !!v || "Site requerido"],
    // receiveEmail: false,
    // receiveSMS: false,
    // clientType: null,
    // items: ["Revenda", "Transportadora", "Franquia", "Fornecedor"],
  }),

  computed: {
    // currentTitle() {
    //   switch (this.step) {
    //     case 1:
    //       return "Informações";
    //     case 2:
    //       return "Localização";
    //     case 3:
    //       return "Informações para Contato";
    //     default:
    //       return "Account created";
    //   }
    // },
  },

  methods: {
    // validate() {
    //   return this.$refs.firstForm.validate();
    // },
    // next() {
    //   if (this.step === 1) {
    //     if (this.$refs.firstForm.validate()) {
    //       this.step += 1;
    //     }
    //   } else if (this.step === 2) {
    //     if (this.$refs.secondForm.validate()) {
    //       this.step += 1;
    //     }
    //   } else if (this.step === 3) {
    //     if (this.$refs.thirdForm.validate()) {
    //       this.step += 1;
    //     }
    //   }
    // },
    // back() {
    //   this.step -= 1;
    // },
  },
}
</script>

<style scoped></style>
